// header.component.ts
import { Component, effect, OnInit, signal, computed, untracked } from '@angular/core';
import { ThemeService } from '@services/core/theme/theme.service';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { TitleCasePipe } from '@angular/common';
import { GlobalSearchBarComponent } from '../../../components/global-search-bar/global-search-bar.component';
import { LoginSubjBubbleComponent } from '@app/areas/users/components/login-subj-bubble/login-subj-bubble.component';
import { RegionSelectionComponent } from '@app/areas/users/components/region-selection/region-selection.component';
import { AppAuthService } from '@services/core/auth/app-auth.service';
import { RegionService } from '@app/areas/auth/services/region.service';
import { SupportedRegion } from '@app/areas/auth/models/supported-region.interface';
import { IdentityUserRegion } from '@app/areas/users/models/identity-user.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    GlobalSearchBarComponent,
    TitleCasePipe,
    LocalizeTextPipe,
    LoginSubjBubbleComponent,
    RegionSelectionComponent,
  ],
})
export class HeaderComponent implements OnInit {
  defaultRegion = signal<IdentityUserRegion>('australia-southeast1');

  // popup is shown by default when suggested region exists
  suggestedRegionOpen = signal(false);

  suggestedRegion = computed(() => this.r.suggestedRegion$() ?? null);

  constructor(
    public theme: ThemeService,
    public auth: AppAuthService,
    public r: RegionService
  ) {
    effect(() => {
      const selectedR = this.r.selectedRegion$();
      const userR = this.auth.user$()?.identityProfile?.region;
      const newR = selectedR ?? userR;
      this.defaultRegion.set(newR);

      const sr = this.r.suggestedRegion$();

      // Auto-open when a suggestion appears (but don't re-open if user dismissed it)
      if (sr && !untracked(() => this.suggestedRegionOpen())) {
        this.suggestedRegionOpen.set(true);
      }

      // Auto-close if suggestion disappears
      if (!sr && untracked(() => this.suggestedRegionOpen())) {
        this.suggestedRegionOpen.set(false);
      }
    });
  }

  ngOnInit(): void {}

  handleRegionChange(value: SupportedRegion): void {
    this.r.selectRegion(value.id);
    this.auth.refreshUserPractitionerData();
  }

  applySuggestedRegion(): void {
    const sr = this.suggestedRegion();
    if (!sr) return;

    this.r.selectRegion(sr.id);
    this.auth.refreshUserPractitionerData();
    this.suggestedRegionOpen.set(false);
  }

  dismissSuggestedRegion(): void {
    // close only (keeps suggestion in service, but user won't see it again this session unless it changes)
    this.suggestedRegionOpen.set(false);

    // Optional: if you add this to RegionService, it will truly clear it.
    const svc: any = this.r as any;
    if (typeof svc.dismissSuggestedRegion === 'function') {
      svc.dismissSuggestedRegion();
    }
  }
}
